import { isEmpty } from 'lodash';

import { XVIError } from './xvi-error.model';
import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';

export class XVIConnectionError extends XVIError {
  public title: string;
  public constructor(params: {
    errorMessage?: string;
    i18nService: XVII18nService;
  }) {
    const { errorMessage, i18nService } = params;

    super(
      i18nService.t(
        isEmpty(errorMessage)
          ? I18n.ErrorMessages.InternetConnectionIsAbsent
          : errorMessage,
      ),
    );
    this.title = i18nService.t(I18n.ErrorMessages.CONNECTION_ERROR);
  }
}
